import React from 'react';
import useCountdown from 'features/SpilKlub/state/useCountdown';
import { formatDate } from 'utils/UiHelper';
import arrow from 'images/icons/big9/default_arrow.svg';
import useAuth from 'features/SpilKlub/state/useAuth';
import { countDeadlineTime } from 'features/SpilKlub/state/helpers';

const PoolCard = ({ item, groupName, onClick, finished = false }) => {
    const { userId } = useAuth();
    const deadlineTime = countDeadlineTime(
        item?.pool?.poolSettings?.deadlineTime,
        item?.pool?.startTime
    );
    const { isEnding, timeLeft } = useCountdown({
        deadlineTime,
    });

    const calculateShares = (shares) => {
        return shares.reduce(
            (totalShares, share) => totalShares + share.numberOfShares,
            0
        );
    };

    const boughtShares = item?.pool?.shares.length
        ? calculateShares(item.pool.shares)
        : '0';

    return (
        <div className={'sk-game-card fade-in-fast'} onClick={onClick}>
            <div className={'sk-game-card-content'}>
                <div className={'flex space-between'}>
                    <h5 className={'no-margin capitalize'}>
                        {item?.pool?.startTime
                            ? formatDate(
                                  item.pool.startTime,
                                  'dddd [D.] DD.MM.YY'
                              )
                            : ''}
                    </h5>
                    <span
                        className={`group-block no-margin ${
                            isEnding && !finished ? 'red' : 'black'
                        }`}
                    >
                        {!finished ? timeLeft : 'Afsluttet'}
                    </span>
                </div>
                <span>{groupName}</span>
                <div className={'group-block-wrapper flex space-between'}>
                    <div>
                        <span
                            className={`group-block ${boughtShares >=
                                item?.pool?.poolSettings?.sharesLimit &&
                                'red'}`}
                        >
                            Andele {boughtShares} af{' '}
                            {item?.pool?.poolSettings?.sharesLimit || 0}
                        </span>
                        <span className="group-block">
                            {item?.pool?.poolSettings?.sharePrice || '0'} kr.
                        </span>
                        {item?.pool?.shares.some(
                            (share) => share.userId === userId
                        ) && (
                            <span className="group-block group-block-sold-out">
                                Købt
                            </span>
                        )}
                        {item?.pool?.winAmount > 0 && (
                            <span className="group-block group-block-sold-out">
                                Gevinst
                            </span>
                        )}
                    </div>
                    <div className={'open-pool-btn'}>
                        <img src={arrow} alt="arrow" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PoolCard;
